import { Activity } from '~/core/model/activity.model';

const DEFAULT_PERIOD_REFUND_TIME = 'P1D'; // default fallback value

/*
  The expected format for `refundTimeByActivityType` is as follows (JSON) :
          {"BIRTHDAY": "P15D"}
              ^           ^
        ActivityType   Duration
*/

export function getRefundTimeLimit(
  activity: Activity,
  refundTimeByActivityType: object
): string {
  return (
    activity?.refundTimeLimit ||
    refundTimeByActivityType[activity?.type] ||
    DEFAULT_PERIOD_REFUND_TIME
  );
}
